import { useContext } from "react";
import { useSelector } from "react-redux";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import DELETE_ICON_WHITE from "../img/delete_icon.svg";
import plusTrashIcon from "../img/plus-trash-icon.svg";
import { X } from "lucide-react";
import { Checkbox } from "./ui/checkbox";
import IconButton from "../shared/IconButton";

export default function ItemsDeletionStripe(props) {
  const languageContext = useContext(LanguageContext);
  const direction = useSelector((state) => state.mode.direction);
  const isRtl = direction === "rtl";
  const menuSelectionText = getMenuSelectionText();
  const hasSelection = props.countSelectedItems > 0;

  const topPosition = props.isStripeVisible ? 40 : 0;

  function getMenuSelectionText() {
    let menuSelectionText = `${props.countSelectedItems} ${
      props.countSelectedItems === 1
        ? languageContext.getTranslation(appConst.SELECTED_ITEM)
        : languageContext.getTranslation(appConst.SELECTED_ITEMS)
    }`;

    if (props.selectedAll()) {
      menuSelectionText = `${languageContext.getTranslation(
        appConst.TOTAL
      )} (${menuSelectionText})`;
    }

    return menuSelectionText;
  }

  if (!props.isDeletionMode) {
    return (
      <div
        className="basket_toolbar basket-page-start-stripe mb-1"
        data-testid="basket-toolbar"
        style={{
          position: "sticky",
          top: topPosition,
          zIndex: 10,
          height: "40px",
          boxSizing: "border-box",
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <IconButton
          className="p-2 max-md:pe-4"
          aria-label="delete items"
          onClick={props.onToggleDeletionMode}
          data-testid="basket-toggle-deletion-mode"
        >
          <img
            src={plusTrashIcon}
            alt="delete items"
            style={{ width: 24, height: 24 }}
          />
        </IconButton>
      </div>
    );
  }

  return (
    <div
      className="basket_toolbar basket-page-start-stripe"
      data-testid="basket-toolbar"
      style={{
        backgroundColor: "#DADADA",
        color: "#404040",
        height: "40px",
        minHeight: "40px",
        maxHeight: "40px",
        boxSizing: "border-box",
        position: "sticky",
        top: 0,
        zIndex: 10,
        marginBottom: "12px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        direction,
      }}
    >
        <div
          className="basket_deletion_stripe_inner"
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            fontSize: "14px",
            width: "100%",
            minWidth: "fit-content",
            justifyContent: "space-between",
            lineHeight: "40px",
            boxSizing: "border-box",
            paddingInlineStart: isRtl
              ? props.hasScroller
                ? "32px"
                : "4vw"
              : "4vw",
            paddingInlineEnd: "12px",
          }}
        >
        <div className="count_selected_items_and_icon">
          <div>{menuSelectionText}</div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <img
              className="delete_icon_white"
              src={DELETE_ICON_WHITE}
              onClick={hasSelection ? props.beforeDeleting : undefined}
              data-testid="basket-delete-selected"
              style={{
                opacity: hasSelection ? 1 : 0.5,
                cursor: hasSelection ? "pointer" : "not-allowed",
                width: 24,
                height: 24,
              }}
            />
            <IconButton
              className="p-[2px] text-ink"
              aria-label="exit delete mode"
              onClick={props.onToggleDeletionMode}
              data-testid="basket-exit-deletion-mode"
            >
              <X size={16} />
            </IconButton>
          </div>
        </div>
        <div
          style={{
            marginInlineStart: 5,
            marginInlineEnd: 17,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Checkbox
            aria-label="select all items"
            checked={props.selectAll}
            onCheckedChange={(checked) =>
              props.handleSelectedAll({ target: { checked: !!checked } })
            }
            variant="neutral"
            className="h-5 w-5 md:h-7 md:w-7 rounded-full"
            data-testid="basket-select-all"
          />
        </div>
      </div>
    </div>
  );
}
